import iframeResize from '@iframe-resizer/parent';

const initIframeResize = (elements: NodeListOf<HTMLElement>): void => {
    elements.forEach((el) => iframeResize({ license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz' }, el));
};

export default initIframeResize;
